import { render } from "./MarketplaceSidebar.vue?vue&type=template&id=20614bf2&scoped=true"
import script from "./MarketplaceSidebar.vue?vue&type=script&lang=js"
export * from "./MarketplaceSidebar.vue?vue&type=script&lang=js"

import "./MarketplaceSidebar.vue?vue&type=style&index=0&id=20614bf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20614bf2"]])

export default __exports__